/**
 * Sentences the Content tab shows. Role names stay out of these strings.
 */

/** Shown while a story is being written. */
export const WRITING = 'Writing your reel…';

/** Added when the home computer is writing because a cloud limit was hit. */
export const CONTINUING_ON_COMPUTER = 'Continuing on your computer.';

/** Wait for one still and a slow move. */
export const ABOUT_STILL = 'About 2 minutes';

/** What the still path does. */
export const STILL_HINT = 'A still picture, then a slow move.';

/** Wait when the subject has to move. */
export const ABOUT_MOVING = 'About 3 minutes a scene.';

/** Queue missing or unreachable. */
export const HOME_OFF = 'Home computer is off.';

/** No Groq key, Gemini key, or queue address. */
export const TEXT_UNAVAILABLE = 'Writing needs a text key or your computer.';
